var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTriangleUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10,
    height: 6
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon-triangle-up_svg__a",
    width: "107%",
    height: "102.3%",
    x: "-3.5%",
    y: "-.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "icon-triangle-up_svg__b",
    d: "M2 1h196a2 2 0 012 2v598H0V3a2 2 0 012-2z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12 -98)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#icon-triangle-up_svg__a)",
    xlinkHref: "#icon-triangle-up_svg__b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#FFF",
    strokeLinejoin: "square",
    d: "M.5 600.5h199V3a1.5 1.5 0 00-1.5-1.5H2A1.5 1.5 0 00.5 3v597.5z"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#7D7D7D",
    fontFamily: "SpoqaHanSans-Regular, SpoqaHanSans",
    fontSize: 12,
    transform: "translate(-12 -98)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 11,
    y: 14
  }, "\uD558\uC704 \uCE74\uD14C\uACE0\uB9AC \uAC80\uC0C9")), /*#__PURE__*/React.createElement("text", {
    fill: "#000",
    fontFamily: "SpoqaHanSans-Regular, SpoqaHanSans",
    fontSize: 12,
    transform: "translate(-12 -98)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 11,
    y: 90
  }, " \uC2DD\uB300\uBE44"), /*#__PURE__*/React.createElement("tspan", {
    x: 11,
    y: 130
  }, "\uC2DD\uB300\uBE44-\uC544\uCE68"), /*#__PURE__*/React.createElement("tspan", {
    x: 11,
    y: 170
  }, "\uC2DD\uB300\uBE44-\uC810\uC2EC"), /*#__PURE__*/React.createElement("tspan", {
    x: 11,
    y: 210
  }, "\uC2DD\uB300\uBE44-\uC800\uB141"), /*#__PURE__*/React.createElement("tspan", {
    x: 11,
    y: 250
  }, "\uC2DD\uB300\uBE44-\uC57C\uADFC"), /*#__PURE__*/React.createElement("tspan", {
    x: 11,
    y: 290
  }, "\uC2DD\uB300\uBE44-\uD68C\uC758"), /*#__PURE__*/React.createElement("tspan", {
    x: 11,
    y: 330
  }, " \uBE44\uD488"), /*#__PURE__*/React.createElement("tspan", {
    x: 11,
    y: 370
  }, " \uC6B4\uC1A1\uBE44")), /*#__PURE__*/React.createElement("path", {
    fill: "#95A7BD",
    d: "M5 0l5 6H0z"
  }))));
}
export default __webpack_public_path__ + "0294d493bcde78974a8cd94c562958b5.svg";
export { SvgIconTriangleUp as ReactComponent };